import styled from "@emotion/styled"
import { AppBar, Container, IconButton, MenuItem } from "@mui/material"
import CustomImage from "../custom-image/custom-image.component"
import CustomLink from "../custom-link/custom-link.component"
import CustomButton from "../custom-button/custom-button.component"

export const HeaderSection = styled(AppBar)`
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: ${({ theme }) => theme.typography.pxToRem(28)};
  padding-bottom: ${({ theme }) => theme.typography.pxToRem(28)};
`

export const Wrapper = styled(Container)``

export const ContentContainer = styled.div`
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.primary.light};
  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.07);
  height: ${({ theme }) => theme.navHeight}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
`

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.typography.pxToRem(60)};
`

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.typography.pxToRem(12)};
`

export const ImageContainer = styled.div`
  width: 126px;
  height: 32px;
`

export const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.typography.pxToRem(35)};

  ${({ theme }) => theme.breakpoints.down(1080)} {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 2rem;
  }
`

export const LogoImage = styled(CustomImage)`
  width: 125.538px;
  height: 32px;
`

export const Link = styled(CustomLink)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.45px;
  text-transform: uppercase;

  &:hover {
    text-decoration: underline;
  }

  ${({ theme }) => theme.breakpoints.down(1080)} {
    font-size: ${({ theme }) => theme.typography.pxToRem(40)};
    color: ${({ theme }) => theme.palette.primary.light};
  }
`

export const LoginButton = styled(CustomButton)`
  height: 52px;
  display: flex;
  column-gap: 1rem;
  /* background-color: transparent !important; */
  /* border: 1px solid #dae2ef; */
  /* color: ${({ theme }) => theme.palette.secondary.main}; */
  /* &:hover {
    border: 1px solid var(--Brand-green, #00a179);
    background: rgba(0, 161, 121, 0.1) !important;
  } */

  path {
    fill: ${({ theme }) => theme.palette.primary.light};
  }

  ${({ theme }) => theme.breakpoints.down(1080)} {
    background-color: ${({ theme }) => theme.palette.primary.light} !important;
    border: 1px solid #dae2ef;
    color: ${({ theme }) => theme.palette.secondary.main};
    path {
      fill: ${({ theme }) => theme.palette.secondary.main};
    }
`

export const MenuButton = styled(IconButton)`
  svg {
    color: ${({ theme }) => theme.palette.tertiary.dark} !important;
    height: 30px;
    width: 30px;
  }
`
export const Item = styled(MenuItem)`
  a {
    color: ${({ theme }) => theme.palette.text.content};
    text-decoration: none;
  }
  padding: 0.5rem 1.75rem;
  :not(:last-child)::after {
    content: "";
    border-radius: 5px;
    display: block;
    position: absolute;
    width: calc(100% - 3.5rem);
    height: 1px;
    bottom: 0;
    left: 1.75rem;
    opacity: 0.15;
    background: #000;
  }
`
export const MenuBox = styled.div`
  position: relative;
  border-radius: 5px;
  background: white;
  margin-top: 1.5rem;
  width: 140px;
  padding: 1rem 0;
  //border: 0.5px solid ${({ theme }) => theme.palette.secondary.main};
  :before {
    background-color: white;
    content: "";
    border-radius: 5px;
    display: block;
    position: absolute;
    width: 45px;
    height: 45px;
    top: -9px;
    transform: rotate(45deg);
    left: 1rem;
    //border: 0.5px solid ${({ theme }) => theme.palette.secondary.main};
    z-index: -1;
  }
`
